/**
 * 通道隔离显示（DESIGN.md §7.1 补充：通道面板）。
 *
 * 只查看某一个 R/G/B 通道时，Photoshop 把它画成一张灰度图——不是"其余
 * 通道清零变暗"，是三个通道都换成那一个通道的值。不接 `composite.ts`：
 * 这是纯粹的显示期后处理，加在 render-bridge 拿到最终合成结果之后，
 * 合成管线本身（含调整图层等依赖真实 RGB 的逻辑）完全不知道这件事。
 */

export type ChannelIsolation = 'r' | 'g' | 'b';

const CHANNEL_BYTE_OFFSET: Readonly<Record<ChannelIsolation, number>> = { r: 0, g: 1, b: 2 };

/**
 * 原地把一份 RGBA8 缓冲改成"只看 `channel` 那个通道"的灰度视图：
 * R=G=B=该通道原值，alpha 强制不透明（PS 通道面板里单通道视图本身
 * 就是一张不透明的灰度图，跟原图的透明区域无关）。
 */
export function isolateChannel(
  rgba: Uint8Array | Uint8ClampedArray,
  channel: ChannelIsolation,
): void {
  const offset = CHANNEL_BYTE_OFFSET[channel];
  for (let i = 0; i < rgba.length; i += 4) {
    const value = rgba[i + offset]!;
    rgba[i] = value;
    rgba[i + 1] = value;
    rgba[i + 2] = value;
    rgba[i + 3] = 255;
  }
}
